import React, { useEffect, useState, useMemo } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Assignment from "@material-ui/icons/Assignment";
import { Outlet, useLocation } from "react-router-dom";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import axios from "../../utils/axiosInstance";
import { useNavigate } from "react-router-dom";
import { MantineReactTable } from "mantine-react-table";
import swal from "sweetalert2";
import { Box, ActionIcon, Tooltip } from "@mantine/core";
import { IconEye } from "@tabler/icons-react";
import { IconTrash, IconEdit } from "@tabler/icons-react";
import styles from "assets/jss/material-dashboard-pro-react/views/validationFormsStyle.js";
import moment from "moment";
import Pagination from "rc-pagination";
import { CircularProgress, debounce } from "@material-ui/core";
import { toast } from "react-toastify";
const useStyles = makeStyles(styles);

export default function ManageLotteries() {
  const location = useLocation();
  const [users, setUsers] = useState([]);
  const [paginationData, setPaginationData] = useState({
    currentPage: 1,
    pageSize: 10,
    totalPages: 0,
    totalItems: 0,
  });
  const [loading, setLoading] = useState(false);
  const [showLotteryList, setShowLotteryList] = useState(true);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [searchText, setSearchText] = useState("");
  const lotteryData = users?.data;
  const [validationErrors, setValidationErrors] = useState({});
  const [tableData, setTableData] = useState([]);
  const [openView, setOpenView] = useState(false);
  const [debouncedSearchText, setDebouncedSearchText] = useState("");
  const [loadingDownload, setLoadingDownload] = useState(false);
  const classes = useStyles();
  const navigate = useNavigate();

  const [formValues, setFormValues] = React.useState({
    lotteryName: "",
    ticketPrice: 0,
    numOfTicketOnSale: 0,
    ticketCountdown: 0,
    startDate: "",
    endDate: "",
    startTime: "",
    endTime: "",
    lotteryDrawDate: "",
    lotteryDrawTime: "",
    totalDraw: 0,
    firstDrawPrize: 0,
    secondDrawPrize: 0,
    thirdDrawPrize: 0,
    instruction: "",
    maxRpmLotteryWheel: 0,
    decelarationOfLotteryWheel: 20,
    maxNumOfTickets: 0,
    status: "",
    rank:0
  });
  const isViewing = location.pathname.includes("viewLottery");
  const isEdit = location.pathname.includes("editLottery");
  const columns = useMemo(() => [
    {
      accessorFn: () => "image",
      id: "Image",
      header: "Lottery Image",
      size: 100,
      Cell: ({ row }) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "16px",
          }}
        >
          <img
            alt="avatar"
            height={30}
            src={`${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/uploads/${row.original.image}`}
            style={{ borderRadius: "50%" }}
          />
        </div>
      ),
    },
     {
      header: "Rank",
      accessorKey: "rank",
      size: 10,
    },
    {
      header: "Lottery Id",
      accessorKey: "_id",
      size: 10,
    },
    {
      header: "Lottery Name",
      accessorKey: "lotteryName",
      size: 10,
    },
    {
      header: "Price",
      accessorKey: "ticketPrice",
      size: 10,
    },
    {
      header: "Tickets on Sale",
      accessorKey: "numOfTicketOnSale",
      size: 10,
    },
    {
      header: "Sold Tickets",
      accessorKey: "numOfTicketSold",
      size: 10,
    },
    {
      header: "Total Draw",
      accessorKey: "totalDraw",
      size: 10,
    },
  ]);



  useEffect(() => {
    if (location.pathname === "/admin/ManageLotteries") {
      setShowLotteryList(true);
    }
  }, [location.pathname]);




  useEffect(() => {

    getData(debouncedSearchText);
  }, [page, limit, debouncedSearchText, location.pathname]);


  const getData = async (searchText) => {
    setLoading(true);
    const token = localStorage.getItem("token");
    console.log(token);
    await axios
      .get(`${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/lotterylist`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Access-Control-Allow-Origin": "*",
        },
        params: { page, limit, search: searchText },
      })
      .then((res) => {
        console.log(res , "resawer");
        setUsers(res.data);
        setFormValues({
          lotteryName: res.data.data.lotteryName,
          ticketPrice: res.data.data.ticketPrice,
          numOfTicketOnSale: res.data.data.ticketOnSale,
          ticketCountdown: res.data.data.ticketCountdown,
          startDate: res.data.data.startDate,
          endDate: res.data.data.endDate,
          startTime: res.data.data.startTime,
          endTime: res.data.data.endTime,
          lotteryDrawDate: res.data.data.lotteryDrawDate,
          lotteryDrawtime: res.data.data.lotteryDrawTime,
          totalDraw: res.data.data.totalDraw,
          firstDrawPrize: res.data.data.firstDrawPrize,
          secondDrawPrize: res.data.data.secondDrawPrize,
          thirdDrawPrize: res.data.data.thirdDrawPrize,
          instruction: res.data.data.instruction,
          maxRpmLotteryWheel: res.data.data.maxRpmLotteryWheel,
          decelarationOfLotteryWheel: res.data.data.decelarationOfLotteryWheel,
          maxNumOfTickets: res.data.data.maxNumOfTickets,
          status: res.data.data.status,
          rank:res.data.data.rank,
        });
        setPaginationData({
          currentPage: res.data.pagination.currentPage,
          pageSize: res.data.pagination.pageSize,
          totalPages: res.data.pagination.totalPages,
          totalItems: res.data.pagination.totalRecords,
        });
      })

      .catch((err) => {
        console.log(err);
        if (
          err.response.data.message ==
          "For security reasons, we locked your account.Please login to continue"
        ) {
          localStorage.removeItem("token");
          window.location.assign("/auth/login-page");
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleDelete = async (row) => {
    const token = localStorage.getItem("token");
    const result = await swal.fire({
      title: "Confirm Deletion",
      text: "Are you sure you want to delete?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
      allowOutsideClick: false,
    });

    if (result.isConfirmed) {
      try {
        const response = await axios.delete(
          `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/lottery/${row.original._id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Access-Control-Allow-Origin": "*",
            },
          }
        );
        console.log(response);
        swal.fire({
          icon: "success",
          text: "Deleted! You have successfully deleted the Lottery.",
        });
        getData();
      } catch (error) {
        console.error(error);
        if (error?.response?.status === 403) {
          await swal.fire({
            icon: "error",
            title: "Error",
            text: "You do not have permission to delete this user.",
          });
        } else {
          swal.fire({
            icon: "error",
            text: "An error occurred while deleting the Lottery.",
          });
        }

      }
    } else if (result.isDismissed) {
      swal.fire({
        icon: "info",
        text: "Cancelled. The Lottery was not deleted.",
      });
    }
  };



  const handleCancelRowEdits = () => {
    setValidationErrors({});
  };

  const handleOpenEditModal = (rows) => {
    const endDateTime = rows.original.endDateTime;
    if (moment().isAfter(moment(endDateTime))) {
      showNotification({
        title: "Lottery Ended",
        message: "Lottery end time has finished. You cannot edit this lottery.",
        color: "red",
      });
      return;
    }
    navigate(`editLottery/${rows.original._id}`);
  };
  const isLotteryEnded = (row) => {
    return moment().isAfter(moment(row.original.endDateTime));
  };

  const handleSaveRowEdits = async ({ exitEditingMode, row, values }) => {
    const token = localStorage.getItem("token");
    if (!Object.keys(validationErrors).length) {
      tableData[row.index] = values;
      setTableData([...tableData]);
      exitEditingMode();
      let formDataValue = {
        lotteryName: formValues.lotteryName,
        ticketPrice: formValues.ticketPrice,
        numOfTicketOnSale: formValues.ticketOnSale,
        ticketCountdown: formValues.ticketCountdown,
        startDate: formValues.startDate,
        endDate: formValues.endDate,
        startTime: formValues.startTime,
        endTime: formValues.endTime,
        lotteryDrawDate: formValues.lotteryDrawDate,
        lotteryDrawtime: formValues.lotteryDrawTime,
        totalDraw: formValues.totalDraw,
        firstDrawPrize: formValues.firstDrawPrize,
        secondDrawPrize: formValues.secondDrawPrize,
        thirdDrawPrize: formValues.thirdDrawPrize,
        instruction: formValues.instruction,
        maxRpmLotteryWheel: formValues.maxRpmLotteryWheel,
        decelarationOfLotteryWheel: formValues.decelarationOfLotteryWheel,
        maxNumOfTickets: formValues.maxNumOfTickets,
        status: formValues.status,
      };
      await axios
        .put(
          `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/lottery/lotteryId=${row.original._id}`,
          formDataValue,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Access-Control-Allow-Origin": "*",
            },
          }
        )
        .then((res) => {
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
          if (
            err.response.data.message ==
            "For security reasons, we locked your account.Please login to continue"
          ) {
            localStorage.removeItem("token");
            window.location.assign("/auth/login-page");
          }
        });
    }
  };
  const updatePage = (newPage) => {
    setPage(newPage);
  };
  const debouncedSearch = useMemo(() => debounce((value) => {
    setDebouncedSearchText(value);
    if (value === "") {
      setPage(1);
      setLimit(10);
    }
  }, 500), []);
  const handleDownload = async () => {
    try {
      setLoadingDownload(true);
      const response = await axios.get(`${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/lotterylistDownload`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Access-Control-Allow-Origin": "*",
        },
        responseType: 'blob',
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'Lottery_List.xlsx');
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Download error:', error);
      if (error.response.status === 403) {
        toast.error("You do not have permission to download this file.");
        return;
      }
    } finally {
      setLoadingDownload(false);
    }
  }
  return (
    <>
      {!isEdit && !isViewing && showLotteryList && (
        <GridContainer>
          <GridItem xs={12}>
            <Card>
              <CardHeader color="rose" icon>
                <CardIcon color="rose">
                  <Assignment />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>Manage Lottery</h4>
                <Button
                  color="#3C37FF"
                  style={{ float: "right" }}
                  onClick={() => {
                    setShowLotteryList(false);
                    navigate("createLottery");
                  }}
                >
                  Add Lottery
                </Button>
              </CardHeader>
              {loading ? (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100vh",
                  }}
                >
                  <CircularProgress />
                </Box>
              ) : (
                <CardBody>
                  <MantineReactTable
                    columns={columns}
                    // enableRowNumbers
                    positionActionsColumn="first"
                    displayColumnDefOptions={{
                      "mrt-row-actions": {
                        mantineTableHeadCellProps: {
                          align: "center",
                        },
                        size: 120,
                      },
                    }}
                    data={lotteryData || []}
                    enableColumnFilters={false}
                    enableColumnFilterModes={false}
                    enableGlobalFilter={false}
                    enableFilters={false}
                    enableFullScreenToggle={false}
                    enableDensityToggle={false}
                    enableHiding={false}
                    enableColumnResizing={false}
                    enableColumnOrdering={false}
                    initialState={{ showColumnFilters: true }}
                    positionToolbarAlertBanner="bottom"
                    enablePagination={false}
                    enableEditing
                    onEditingRowSave={handleSaveRowEdits}
                    onEditingRowCancel={handleCancelRowEdits}
                    renderTopToolbarCustomActions={({ table }) => (
                      <Box
                        sx={{
                          display: "flex",
                          gap: "16px",
                          flexWrap: "wrap",
                          padding: "16px",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            border: "1px solid #ccc",
                            borderRadius: "8px",
                            padding: "6px 12px",
                            width: "300px",
                            backgroundColor: "#fff",
                          }}
                        >
                          <i className="material-icons" style={{ color: "#aaa", marginRight: "8px" }}>
                            search
                          </i>
                          <input
                            type="text"
                            value={searchText}
                            placeholder="Search by lottery name or ID"
                            onChange={(e) => {
                              setSearchText(e.target.value);
                              debouncedSearch(e.target.value);
                            }}
                            style={{
                              border: "none",
                              outline: "none",
                              width: "100%",
                              fontSize: "14px",
                            }}
                          />

                        </Box>
                        {loadingDownload ? (
                          <CircularProgress size={24} style={{ color: "black" }} />
                        ) : (
                          <Button
                            onClick={handleDownload}
                            style={{ marginLeft: "auto" }}

                          >
                            Export All Rows
                          </Button>
                        )}
                      </Box>
                    )}
                    renderRowActions={({ row }) => (
                      <Box sx={{ display: "flex", gap: "16px" }}>
                        <Tooltip withArrow position="center" label="view">
                          <ActionIcon
                            onClick={() =>
                              navigate(
                                `/admin/ManageLotteries/viewLottery/${row.original._id}`
                              )
                            }
                          >
                            <IconEye />
                          </ActionIcon>
                        </Tooltip>

                        <Tooltip
                          withArrow
                          position="left"
                          label={
                            isLotteryEnded(row)
                              ? "Cannot Edit, Lottery Ended"
                              : "Edit"
                          }
                        >
                          <div style={{ display: "inline-block" }}>
                            <ActionIcon
                              onClick={() => {
                                if (!isLotteryEnded(row)) {
                                  handleOpenEditModal(row);
                                }
                              }}
                              color={isLotteryEnded(row) ? "gray" : "blue"}
                              style={{
                                cursor: isLotteryEnded(row)
                                  ? "not-allowed"
                                  : "pointer",
                              }}
                            >
                              <IconEdit />
                            </ActionIcon>
                          </div>
                        </Tooltip>
                        <Tooltip withArrow position="right" label="Delete">
                          <ActionIcon color="red" onClick={() => handleDelete(row)}>
                            <IconTrash />
                          </ActionIcon>
                        </Tooltip>
                      </Box>
                    )}
                  />
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      marginTop: "20px",
                    }}
                  >
                    <Pagination
                      pageSize={paginationData?.pageSize}
                      onChange={updatePage}
                      current={paginationData?.currentPage}
                      total={paginationData?.totalItems}
                    />
                  </Box>
                </CardBody>
              )}
            </Card>
          </GridItem>
        </GridContainer>
      )}

      <Outlet />
    </>
  );
}
